import { Observable, pipe, UnaryFunction } from 'rxjs';
import { filter } from 'rxjs/operators';
import { isNullish } from '../is-nullish';

export function filterNullish<T>(): UnaryFunction<Observable<T | null | undefined>, Observable<T>> {
  return pipe(filter(isNullish));
}
